import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import TextCell from '~/glm/components/guest-list/cells/name-text-cell';
import GdsGuestModel from '~/glm/models/gds/gds-guest-model';
import GdsUiState from '~/glm/models/gds/gds-ui-state';
import Collection from '~/glm/models/collection';
import styles from './names-cell.scss';

@inject('gdsUiState')
@observer
class NamesCell extends Component {
  static propTypes = {
    gdsUiState: PropTypes.instanceOf(GdsUiState).isRequired,
    guests: PropTypes.oneOfType([
      PropTypes.instanceOf(Collection),
      PropTypes.arrayOf(PropTypes.instanceOf(GdsGuestModel)),
    ]),
    onClick: PropTypes.func,
    disabled: PropTypes.bool,
  };

  render() {
    const { guests, onClick, gdsUiState, disabled = false } = this.props;
    const containerClass = disabled ? styles.disabledMembersContainer : styles.householdMembersContainer;

    return (
      <th
        scope="row"
        className={`${containerClass} ${styles.rowHeader} ${styles.sticky}`}
        onClick={onClick}
        onKeyDown={e => (e.key === 'Enter' ? onClick() : null)}
        tabIndex={0}
      >
        {guests.map(guest => (
          <TextCell
            key={`name-${guest.id}`}
            value={guest.displayName}
            className={classNames(styles.name, {
              [styles.queryingGuest]: gdsUiState.querying,
            })}
            query={gdsUiState.filter}
          />
        ))}
      </th>
    );
  }
}

export default NamesCell;
